<template lang="pug">
include /@ibkr/lib.common/src/icon/basic
include /@ibkr/lib.common/src/icon/arrow
include /@ibkr/lib.common/src/icon/color
ib-dialog(v-model="show", autoclose,  width="1356px", height="100%", class="comp-dialog")
    template(slot="default")
        div(class="iframe-headers", v-if="showQuoteDetails === 'new'")
            div(class="iframe-header-info start-16")
                iframe(
                    :src="iframeURL"
                    style="border:none",
                    width="100%",
                    height="100%",
                    title="Contract Details",
                    id="contractFrame",
                    v-if="reloadIframe"
                )
        div
            span(class="icon-close", @click="close", ref="reload")
                +icon-basic-cancel_filled
</template>

<script>
import api from '../api';
import { mapState, mapActions, mapGetters } from 'vuex';
import tradingChart from '../js/TradingChart.js';

export default {
    name: 'QuoteDetails',
    components: {
    },
    data() {
        return {
            show: false,
            iframeURL: '',
            quoteDetailsCookie: '',
            nightlyCookie: '',
            langCookie: '',
            quoteDetailsCookieValue: '',
            showQuoteDetails: '',
            reloadIframe: false,
            assetClass: '',
        }
    },
    mixins: [tradingChart],
    methods: {
        open(conid, underConid, type) {
            this.iframeURL = '';
            this.langCookie = document.cookie.split('IB_LANG=').pop().split(';').shift();
            this.quoteDetailsCookieValue = document.cookie.split('IB_QD=');
            this.quoteDetailsCookie = document.cookie.split('IB_QD=').pop().split(';').shift();
            
            // IB_NIGHTLY cookie is set manually. When the cookie value is 1, nightly iframe is loaded
            this.nightlyCookie = document.cookie.split('IB_NIGHTLY=').pop().split(';').shift();

            // Update language value for Chinese and Japanese
            switch(this.langCookie) {
                case 'cn':
                    this.langCookie = "zh_CN";
                    break;
                case 'jp':
                    this.langCookie = "ja";
                    break;
            }

            console.debug("IB_LANG:", this.langCookie);

            // If IB_NIGHTLY cookie value is 1 or the app is access through test.php page, nightly iframe URL is used.
            if (this.nightlyCookie === '1' || window.location.href.search(/test.php/) != -1){
                this.iframeURL = `https://www.interactivebrokers.com/free.to.air/nightly/web1/index.html#/?`;
            } else {
                this.iframeURL = `https://www.interactivebrokers.com/free.to.air/web1/index.html#/?`;
            }

            if(type === 'CFD' || type === 'FUT' || type === 'WAR' || type === 'FOP'){
                api.getSecdefData(underConid)
                    .then(response => {
                        this.assetClass = response.secdef[0].assetClass;
                        this.iframeURL += `conid=${conid}&sectype=${type}&underlyingSectype=${this.assetClass}&underlyingConid=${underConid}&lang=${this.langCookie}&ib_entity=${this.selectedDomain}`;
                        console.debug(this.iframeURL);
                    })
            }

            this.showQuoteDetails = "new";

            // Adding iframe to DOM
            setTimeout(() => {
                this.reloadIframe = true;
                this.show = true;
            }, 50)
        },
        getSummary(conid) {
            api.getSummary(conid)
                .then(response => {
                    this.summary = response.summary.replace(/&amp;/g, "&");
                    this.ratios = response.ratios;
                    this.forecast = response.forecast;
                    console.log("Summary API call successfull..",);
                })
                .catch(error => {
                    if(error.response.status != 200){
                        this.isSummary = false;
                    }
                });
            api.getSecdefData(conid)
                .then(response => {
                    this.assetName = response.secdef[0].name;
                    this.listingExchange = response.secdef[0].listingExchange;
                })  
        },
        openDisclosure() {
            window.open("https://ibkr.info/article/2966","_blank", "width=800px, height=500px");
        },
        close() {
            this.show = false;
            this.iframeURL = '';
            this.reloadIframe = false;
            this.resetValues();
        },
        ...mapActions(['setProductResults','setProducts', 'setTypesList'])
    },
    computed: {
        ...mapGetters(['selectedSubDomain', 'selectedDomain']),
        ...mapState(['listedResults', 'productResults', 'summaryy', 'forecst', 'marketdata', 'exchanges'])
    }
}
</script>

<style lang="less">
.comp-dialog {
    border-top: 5px solid #d91222;
}
.iframe-headers {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    padding-top: 16px;
}
.iframe-header-info {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
}
.icon-close {
    position: absolute;
    right: 10px;
    top: 10px;
    svg {
        width: 2rem;
    }
}
</style>